export default __webpack_public_path__ + "static/blob14-3e8f2b2ce5607fd3d16dad181ef6adaa.svg";